module.exports = __webpack_public_path__ + "static/media/ng-logo.fb8b2816.png";